export default "__VITE_ASSET__df708065__"